import { usePersonReadDataContext } from '@aibees/elephant/context';
import { useContactDetailsEnrichmentDescriptionText } from '@aibees/elephant/hooks/people/use-contact-details-enrichment-description-text';
import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ProfileDetailsNoDataProps as Props } from './types';

export const ProfileDetailsNoData = memo(({ className }: Props) => {
  const { api } = usePersonReadDataContext();
  const descriptionText = useContactDetailsEnrichmentDescriptionText(api.data);

  return (
    <Styled.Wrapper
      className={classnames('ProfileDetailsNoData', className)}
      variant="filled"
      color="default"
      sx={SX.root}
    >
      <Typography variant="body3" color="grey.700" fontWeight={400}>
        {descriptionText}
      </Typography>
    </Styled.Wrapper>
  );
});

ProfileDetailsNoData.displayName = 'ProfileDetailsNoData';
